import { render, staticRenderFns } from "./suggestInput.vue?vue&type=template&id=dc764bf8&scoped=true"
import script from "./suggestInput.vue?vue&type=script&lang=js"
export * from "./suggestInput.vue?vue&type=script&lang=js"
import style0 from "./suggestInput.vue?vue&type=style&index=0&id=dc764bf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc764bf8",
  null
  
)

export default component.exports